export enum EventTicketType {
  PAID = "paid",
  FREE = "free",
  DONATION = "donation",
}

export enum EventOccurrenceType {
  /**
   * Standard event with single occurrence and location.
   */
  STANDARD = "standard",

  /**
   * Session based event with serries of occurrences.
   * Sessions are focused on occurrence times.
   */
  SESSION = "session",

  /**
   * Tours are treat as exact same event occurring at difference locations.
   * Tours are focused on occurrence locations.
   */
  TOUR = "tour",
}

export enum EventOccurrenceLocationType {
  /**
   * Location is pending (TBA).
   */
  PENDING = "pending",

  /**
   * Store location.
   */
  LOCATION = "location",

  /**
   * Location uses predefined event venue.
   */
  EVENT_VENUE = "venue",

  /**
   * An address provided inline.
   */
  ADDRESS = "address",

  /**
   * Location is a web link or meeting URL.
   */
  ONLINE_LINK = "online_link",
}
